import React from 'react';
import {
  ReactiveBase,
  ReactiveList,
  SingleList,
  StateProvider,
} from '@appbaseio/reactivesearch';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { FilterSelect } from './FilterSelect';
import { PressImage } from '../../components/press/PressImage';
import reactivesearchTheme from '../../reactivesearchTheme';

function PressImageOverviewPublic({
  url,
  app,
  credentials,
}) {
  return (
    <ReactiveBase
      url={url}
      app={app}
      credentials={credentials}
      enableAppbase
      theme={reactivesearchTheme}
    >
      <div className="filters-block">
        <form className="filter-box pt-5">
          <fieldset>
            <div className="filter-holder">

              <div className="select-filter">
                <SingleList
                  componentId="fair"
                  dataField="fair.title.keyword"
                  filterLabel="Fair"
                  URLParams
                  showSearch={false}
                  render={({
                    data,
                    value,
                    handleChange,
                  }) => (
                    <FilterSelect
                      data={data}
                      value={value}
                      emptyValue="All fairs"
                      onChange={(e) => handleChange(e.target.value)}
                    />
                  )}
                />
              </div>

            </div>
          </fieldset>
        </form>
        <div className="load-more-box">
          <StateProvider
            strict={false}
            render={({ searchState }) => {
              const pageSize = 12;
              const hits = _.get(searchState, 'page.hits.total', 0);
              const numberOfPages = hits > 0 ? Math.ceil(hits / pageSize) : 0;

              return (
                <ReactiveList
                  componentId="page"
                  innerClass={{ pagination: 'pagination reactive-pagination' }}
                  dataField="id"
                  pagination
                  size={pageSize}
                  showEndPage={numberOfPages > 8}
                  pages={numberOfPages > 8 ? 8 : numberOfPages}
                  showResultStats={false}
                  URLParams
                  react={{ and: ['fair'] }}
                  render={({ data }) => (
                    <div className="ajax-load-content row">
                      {data.map((item) => (
                        <PressImage key={item.id} res={item} />
                      ))}
                    </div>
                  )}
                />
              );
            }}
          />
        </div>
      </div>
    </ReactiveBase>
  );
}

PressImageOverviewPublic.propTypes = {
  url: PropTypes.string.isRequired,
  app: PropTypes.string.isRequired,
  credentials: PropTypes.string.isRequired,
};

export { PressImageOverviewPublic };
